// 登录态失效时的跳转入口。
// 这里刻意不 import 任何模块：request.js 与 router/index.js 互相依赖，
// 直接 import router 会形成循环依赖，用「回调注册 + 延迟调用」解开。
let handler = null;
let redirecting = false;

// 由 router/index.js 在模块初始化后注册
export const setAuthRedirectHandler = (fn) => {
    handler = fn;
};

// 供 request.js 的响应拦截器调用
export const redirectToLogin = () => {
    // 一个页面常会并发多个请求，全部返回 509，
    // 用 redirecting 标志把这一批合并成一次跳转，避免重复的跳转。
    // 注意：Toast 提示不在这里去重，每个失败响应仍会各自弹一次
    if (redirecting || !handler) {
        return;
    }
    redirecting = true;
    try {
        handler();
    } catch (e) {
        // 跳转失败不能影响调用方（request.js）的错误处理链路
        console.error('redirectToLogin failed:', e);
    } finally {
        // 1s 后解除，避免后续真的需要再次跳转时被永久挡住
        setTimeout(() => {
            redirecting = false;
        }, 1000);
    }
};
